import { useQuery } from "@tanstack/react-query";
import useApiLeaderboard from "./useLeaderboard";
import PageParams from "../interfaces/pageParams";

const usePagedLeaderboard = (params: PageParams) => {
    const { getPagedLeaderboard } = useApiLeaderboard();

    return useQuery({
        queryKey: ["pagedLeaderboard", params],
        queryFn: () => getPagedLeaderboard({params: { ...params }}),
        staleTime: 1000 * 60 * 5,
        placeholderData: (previousData) => previousData,
    })
}

export default usePagedLeaderboard;